import script from "./visitor.vue?vue&type=script&setup=true&lang=ts"
export * from "./visitor.vue?vue&type=script&setup=true&lang=ts"

import "./visitor.vue?vue&type=style&index=0&id=5a9f72da&lang=scss"

const __exports__ = script;

export default __exports__